import React from 'react'
import OwlCarousel from "react-owl-carousel"
import "owl.carousel/dist/assets/owl.carousel.min.css"
import "owl.carousel/dist/assets/owl.theme.default.min.css"
import AOS from 'aos';
import { useLanguage } from '../../context/LanugageContext';
import { reviewsTranslations } from '../../translations/reviews'

AOS.init({
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'animated',
    easing: 'ease-in-out-cubic',
    duration: 1600
});

const responsive = {
    0: { items: 1 },
    800: { items: 2 },
    1000: { items: 3 }
};

const Reviews = () => {
    const { lang } = useLanguage();
    const tr = reviewsTranslations[lang];

    const renderedReviews = tr.reviews.map((review, index) => {
        return (
            <div className="item" key={index}>
                <div className="rating">
                    <span>★★★★★</span>
                </div>
                <p>{review.text}</p>
                <div className="writer">
                    <span className="name">- {review.author}</span>
                </div>
            </div>
        )
    });

    return (
        <div>
            <div className="reviews animated" data-aos="fade-top">
                <h1>{tr.title}</h1>
                <OwlCarousel
                    key={lang}
                    items="3"
                    nav="null"
                    loop="true"
                    responsive={responsive}
                    className="owl-carousel owl-theme"
                >
                    {renderedReviews}
                </OwlCarousel>
            </div>
        </div>
    )
}

export default Reviews